import React from 'react'
import CardTitle from '@auteco/components/sharedComponents/CardTitle'
import { MarkingSection } from '@auteco/components/snopComponents'

const SnopMarkingPage = () => {
    const info = []
    return (
        <>
            <CardTitle title='Configuración de materiales' />
            <MarkingSection />
        </>
    )
}

export { SnopMarkingPage }